import { render, staticRenderFns } from "./color-picker.vue?vue&type=template&id=ff806964&scoped=true"
import script from "./color-picker.vue?vue&type=script&lang=js"
export * from "./color-picker.vue?vue&type=script&lang=js"
import style0 from "./color-picker.vue?vue&type=style&index=0&id=ff806964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff806964",
  null
  
)

export default component.exports